import { addCommitmentNotesEpic } from './state/add-commitment-notes.epic';
import { deleteTranscriptQuotesEpic } from './state/delete-transcript-quotes.epic';
import { reloadEpic } from './state/reload.epic';
import { updateTranscriptEpic } from './state/update-transcript.epic';

export const transcriptDialogEpics = [
    reloadEpic,
    updateTranscriptEpic,
    deleteTranscriptQuotesEpic,
    addCommitmentNotesEpic,
];
